/**
 * Handles two states: not available, deploying
 */
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import Button from '../../../../molecules/Button';
import { ReactComponent as SkeletonNormal } from '../../images/skeleton_normal.svg';
import big_arrow_left from '../../../../assets/images/arrow_left.svg';

interface INotAvailableProps {
  scroll: boolean;
  onDeployRequested: () => void;
  toMarket(): void;
}

const NotAvailable = ({
  scroll,
  onDeployRequested,
  toMarket,
}: INotAvailableProps) => {
  return (
    <>
      <div
        className='simple_tab_selector simple_tab_selector--clickable'
        onClick={toMarket}
      >
        <Image size='s' src={big_arrow_left} />
        <Text size={12} className='simple_tab_selector__tab'>
          Swap
        </Text>
      </div>
      {scroll ? null : (
        <div className='skeleton'>
          <SkeletonNormal />
        </div>
      )}
      <div className='placeholder__text'>
        <Text size={12}>
          In order to create limit orders you need to deploy a proxy contract
          associated to your wallet
        </Text>
      </div>
      <div className='row'>
        <Button
          action={onDeployRequested}
          size='m'
          variant='primary'
          text='Deploy proxy contract'
        />
      </div>
    </>
  );
};

export default NotAvailable;
